import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/OuterServerMail';

const GetOuterServerMailReducer = handleActions({
    [Actions.GetOuterServerMailRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetOuterServerMailReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.GetOuterServerMailFailed]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors.data,
        success: false,
    }),
    [Actions.ClearGetOuterServerMail]: () => ({
        isFetching: false,
        data: null,
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: null,
    errors: {},
    success: undefined,
});

const UpdateOuterServerMailReducer = handleActions({
    [Actions.UpdateOuterServerMailRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.UpdateOuterServerMailReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.UpdateOuterServerMailFailed]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearUpdateOuterServerMail]: () => ({
        isFetching: false,
        data: null,
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: null,
    errors: {},
    success: undefined,
});

const DeleteOuterServerMailReducer = handleActions({
    [Actions.DeleteOuterServerMailRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.DeleteOuterServerMailReceived]: (state) => ({
        ...state,
        isFetching: false,
        success: true,
    }),
    [Actions.DeleteOuterServerMailFailed]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearDeleteOuterServerMail]: () => ({
        isFetching: false,
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    errors: {},
    success: undefined,
});

export default combineReducers({
    getMail: GetOuterServerMailReducer,
    updateMail: UpdateOuterServerMailReducer,
    deleteMail: DeleteOuterServerMailReducer,
});
